import React from 'react';

import TestRuns from '../components/homeScreens/testRuns';
import { useLocation } from 'react-router-dom';

const testRunsPage = (props) => {
    const location = useLocation();
    const data = location.state ? location.state.properties : null
    console.log(data)
    return (
        <TestRuns title='Test Runs' subtitle='Some details related to running Standalone Messages goes here'  result={data?.result ?? null}
        direction={data?.direction ?? null}
        triggerMessage={data?.triggerMessage ?? null}
        startDate={data?.startDate ?? null}
        endDate={data?.endDate ?? null}
        isdashboard={data?.isdashboard ?? null}
        batchId={data?.batchId ?? null}
        isbatchRun={data?.isbatchRun ?? null} />
    )
}

export default testRunsPage;
